import { render, staticRenderFns } from "./UserstoryViewOptionsDrawer.vue?vue&type=template&id=587ed1a5&"
import script from "./UserstoryViewOptionsDrawer.vue?vue&type=script&lang=js&"
export * from "./UserstoryViewOptionsDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports